class CustomisationsHandler extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    console.log( "CustomisationsHandler connectedCallback" );
    this.productForm = null;
    this.data = {
      products: [],
      pricePerLetter: 0,
      pricePerDigit: 0,
    }
    this.customisation = {
      style: null,
      name: null,
      number: null
    }

    this.init();
    this.bindEvents();
    this.handleURLParams();
  }

  elements = {
    closeButton: this.querySelector('[data-close]'),
    details: this.querySelector('details'),
    summaryTrigger: this.querySelector('summary'),
    contentContainer: this.querySelector('summary + .container'),
    jobInput: this.querySelector('[data-print-job-input]'),
    nameInput: this.querySelector('[data-name-input]'),
    numberInput: this.querySelector('[data-number-input]'),
    styleInput: this.querySelector('[data-style-prop-input]'),
    fontOptions: this.querySelector('[data-font-options]'),
    fontOptionsVariants: this.querySelectorAll('[data-variant-value]'),
    productOptions: this.querySelector('[data-product-options]'),
    standardOptionsSelect: this.querySelector('#standard_options_selector'),
    errorMessage: this.querySelector('[data-error-message]'),
    // calculateButton: this.querySelector('[data-calculate]'),
    summary: {
      name: this.querySelector('[data-name-value]'),
      nameValueCount: this.querySelector('[data-name-value-count]'),
      number: this.querySelector('[data-number-value]'),
      style: this.querySelector('[data-style-value]'),
      totalPrice: this.querySelector('[data-total-price-value]'),
    }
  }

  templates = {
    standardOptions: this.querySelector('template#standard-options'),
    officialOptions: this.querySelector('template#official-options')
  }

  events = {
    handleSummaryClick: (e) => {
      // if current URL contains /collection/ refirect user to product page
      if (window.location.pathname.includes('/collections/') ) {
        const productUrl = e.target.dataset.productUrl;
        if (productUrl) {
          window.location.href = productUrl + '?customise';
          return;
        }
      }

      const timeout = 300;
      setTimeout( () => {
        if (this.elements.details.open) {
          // append to the current window url the customise parameter
          const url = new URL(window.location.href);
          url.searchParams.set('customise', true);
          window.history.pushState({}, '', url.toString());
          
          this.enableCustomPropertyFields();
          this.enableFontOptions();
          this.elements.nameInput.focus();
          this.elements.nameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, timeout);
    },
    handleCloseClick: (e) => {
      this.elements.details.open = false;
      this.disableCustomPropertyFields();
      this.disableFontOptionsInputs();
      this.disableFontOptions();
    },
    handleNameInput: (e) => {
      this.customisation.name = e.target.value.trim(); // ensure no additional spaces are added
      this.updateItemAttributes();
      this.updateSummary();
    },
    handleNumberInput: (e) => {
      this.customisation.number = parseInt(e.target.value) || 0;
      this.updateItemAttributes();
      this.updateSummary();
    },
    handlePrintStyleChange: (e) => {
      // Event delegation is needed as the current target is a common ancestor for all radio buttons.
      // stop if the target is a font color-option
      if ( e.target.dataset.type === 'color-option' ) return;

      const style = e.target.value;
      const target = e.target;
      const label = target.nextElementSibling;
      const colorOptions = target.dataset.options.split(',');
      const selects = label.querySelectorAll('select');
      const inputs = label.querySelectorAll('input:not([type=radio][name=print_style])');
      
      // disable all inputs 
      this.disableFontOptionsInputs();

      // enable/disable option inputs
      [...selects, ...inputs].forEach( el => {
        el.disabled = !(el.ariaDisabled === 'true');
        el.ariaDisabled = !(el.ariaDisabled === 'true');
      })

      if ( colorOptions.length === 1 ) {
        label.querySelector('input[type=radio][data-type=color-option]').checked = true;
      }

      this.customisation.style = style;
      this.elements.styleInput.value = this.customisation.style;
      this.elements.productOptions.dataset.style = this.customisation.style;
      
      this.setPrices();
      this.updateItemAttributes();
      this.updateSummary();
    },
    handleStandardOptionsSelectChange: (e) => {
      const standardOption = this.elements.fontOptions.querySelector('[data-option-type=standard]');
      standardOption.querySelectorAll('select').forEach( select => {
        const found = Array.from(select.options).filter( option => option.dataset.title === e.target.value );
        select.selectedIndex = found[0].index;
      })
      this.updateSummary();
    },
    handleFontOptionVariantClick: (e) => {  
      const target = e.target;
      const fontOption = target.closest('[data-font-option]');
      const options = fontOption.querySelector('input[data-type=font-option]').dataset.options.split(',');
      
      // if target has 1 option only, return inmediately. No need to process.
      if ( options.length === 1 ) return;
      
      // if parent option is not selected, return inmediately
      if ( !fontOption.querySelector('input').checked) return;

      // select the correct letter and number option
      fontOption.querySelectorAll('select').forEach( select => {
        select.selectedIndex = target.dataset.index;
      })

    }
    // handleCalculateClick: (e) => {
    //   console.log( { d: this.data, c: this.customisation });
    //   this.updateSummary();
    // }
  }

  bindEvents() {
    this.elements.summaryTrigger.addEventListener('click', this.events.handleSummaryClick);
    this.elements.closeButton.addEventListener('click', this.events.handleCloseClick);
    this.elements.nameInput.addEventListener('input', this.events.handleNameInput);
    this.elements.numberInput.addEventListener('input', this.events.handleNumberInput);
    this.elements.fontOptions.addEventListener('change', this.events.handlePrintStyleChange);
    this.elements.fontOptionsVariants.forEach( variant => {
      variant.addEventListener('click', this.events.handleFontOptionVariantClick);
    })
    // this.elements.standardOptionsSelect.addEventListener('change', this.events.handleStandardOptionsSelectChange);
    // this.elements.calculateButton.addEventListener('click', this.events.handleCalculateClick);
  }

  init() {
    const official_products = JSON.parse(this.querySelector('[data-block-settings-official-products-data]').innerHTML);
    const standard_products = JSON.parse(this.querySelector('[data-block-settings-standard-products-data]').innerHTML);
    this.data.products = [ ...official_products, ...standard_products ];

    this.productForm = document.querySelector('product-form').form;
  }

  handleURLParams() {
    const url = new URL(window.location.href);
    
    if ( url.searchParams.has('debug') ) {
      this.debug = true;
      this.dataset.debug = true;
    }
    
    if (url.searchParams.has('customise') ) {
      this.elements.summaryTrigger.click();
    }
  }

  getTotalPrice() {
    let totalPrice = 0;
    let namePrice = 0;
    let numberPrice = 0;

    if (this.customisation.name && this.customisation.style ){
      namePrice = this.customisation.name.replace(/\s+/g, '').length * this.data.pricePerLetter;
    }
    if (this.customisation.number && this.customisation.style){
      numberPrice = this.customisation.number.toString().length * this.data.pricePerDigit;
    }
    totalPrice = namePrice + numberPrice;

    return totalPrice;
  }

  setPrices() {
    const style = this.customisation.style;
    const products = this.data.products.filter( product => product.tags.includes(`${ style.toUpperCase() } PRINT`) );
    
    products.forEach( product => {
      if (`${product.title}`.includes('Letter')) {
        this.data.pricePerLetter = product.price;
      }
      if (`${product.title}`.includes('Number')) {
        this.data.pricePerDigit = product.price;
      }
    });
  }
  updateItemAttributes(){
    this.querySelectorAll('[data-name-attribute]').forEach( input => {
      input.value = this.customisation.name?.length ? this.customisation.name.toUpperCase() : null;
    });
    this.querySelectorAll('[data-number-attribute]').forEach( input => {
      input.value = this.customisation.number;
    });
    // No need to update style attribute 
    // this.querySelectorAll('[data-style-attribute]').forEach( input => {
    //   input.value = this.customisation.style;
    // });
  }
  updateSummary(){
    this.elements.fontOptions.querySelectorAll('input[type=number]').forEach( input => {
      if ( input.dataset.optionType === 'letter' ) {
        input.value = this.customisation.name ? this.customisation.name.replace(/\s+/g, '').length: 0;
      }
      if ( input.dataset.optionType === 'number' ) {
        input.value = this.customisation.number ? `${this.customisation.number}`.length : 0;
      }  
    });

    this.elements.summary.name.innerHTML = this.customisation.name;
    this.elements.summary.nameValueCount.innerHTML = `${this.customisation.name?.replace(/\s+/g, '').length} characters`;
    this.elements.summary.number.innerHTML = this.customisation.number;
    this.elements.summary.style.innerHTML = this.customisation.style;
    this.elements.summary.totalPrice.innerHTML = Utilities.formatPrice(this.getTotalPrice());
  }

  enableCustomPropertyFields() {
    this.elements.nameInput.disabled = false;
    this.elements.nameInput.setAttribute('form', this.productForm.attributes.id.value);
    this.elements.numberInput.disabled = false;
    this.elements.numberInput.setAttribute('form', this.productForm.attributes.id.value);
    this.elements.styleInput.disabled = false;
    this.elements.styleInput.setAttribute('form', this.productForm.attributes.id.value);
    this.elements.jobInput.disabled = false;
    this.elements.jobInput.setAttribute('form', this.productForm.attributes.id.value);
  }

  disableCustomPropertyFields() {
    this.elements.nameInput.disabled = true;
    this.elements.nameInput.removeAttribute('form');
    this.elements.numberInput.disabled = true;
    this.elements.numberInput.removeAttribute('form');
    this.elements.styleInput.disabled = true;
    this.elements.styleInput.removeAttribute('form');
    this.elements.jobInput.disabled = true;
    this.elements.jobInput.removeAttribute('form');
  }

  disableFontOptionsInputs(){
    this.elements.fontOptions.querySelectorAll('select,input:not([type=radio][name=print_style])').forEach( el => {
      el.disabled = true;
      el.ariaDisabled = true;
      if ( el.checked ) {
        el.checked = false;
      }
    });
  }
  enableFontOptions(){
    this.elements.fontOptions.querySelectorAll('input[type=radio][name=print_style]').forEach( el => {
      el.disabled = false;
      el.ariaDisabled = false;
    });
  }
  disableFontOptions(){
    this.elements.fontOptions.querySelectorAll('input[type=radio][name=print_style]').forEach( el => {
      el.disabled = true;
      el.ariaDisabled = true;
      if ( el.checked ) {
        el.checked = false;
      }
    });
  }
  hasCustomisation() {
    const { name, number, style } = this.customisation;
    return !!name || !!number || !!style;
  }

  isValid() {
    const { name, number, style } = this.customisation;

    const hasNameOrNumber = !!name || !!number;
    const hasStyle = !!style;

    if (!this.hasCustomisation()) {
      return {
        isValid: true,
        message: 'No customisation. Proceed with product only',
      };
    }

    if (hasNameOrNumber && !hasStyle) {
      return {
        isValid: false,
        message: 'Please select a style to continue.'
      };
    }

    return {
      isValid: true,
      message: 'All good',
    };
  }

}

customElements.define('customisation-app', CustomisationsHandler);